/**
 * 패널 플래닛 하이라이트 스타일 상수
 *
 * SOLID: Single Responsibility — 스타일 정의를 한 곳으로 집중
 * PanelPlanningPage.vue(703줄)와 panelSelectionMixin.js(36줄) 중복 제거
 */
export const PANEL_HIGHLIGHT_STYLE = {
  array: { stroke: '#FF9800', fill: 'rgba(255,152,0,0.14)', width: 3 },
  string: { stroke: '#1E88E5', fill: 'rgba(30,136,229,0.10)', width: 3 },
  module: { stroke: '#00897B', fill: 'rgba(0,137,123,0.14)', width: 3 }
};

/**
 * @param {'array'|'string'|'module'} type
 * @returns {{ stroke: string, fill: string, width: number }}
 */
export function getHighlightStyle(type) {
  return PANEL_HIGHLIGHT_STYLE[type] || PANEL_HIGHLIGHT_STYLE.string;
}
